<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">激活短信管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="status" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in statusArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>平台：</label>
          <el-select v-model="platformType" placeholder="Select" style="width: 7em" @change="platformChange">
            <el-option v-for="item in platformTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>包名/渠道：</label>
          <el-select v-model="channelPackage" placeholder="Select" style="width: 10em" :disabled="platformType == -1" @change="cpChange">
            <el-option v-for="item in channelPackageArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>用户场景：</label>
          <el-select v-model="userScene" placeholder="Select" style="width: 15em">
            <el-option v-for="item in userSceneArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>短信来源：</label>
          <el-select v-model="smsSource" placeholder="Select" style="width: 7.2em">
            <el-option v-for="item in smsSourceArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />-->
<!--        </div>-->
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editActivationDialog(-1)">创建</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column prop="appName" label="应用名" v-if="checkColList.indexOf('应用名') > -1"></el-table-column>
          <el-table-column prop="" label="平台" v-if="checkColList.indexOf('平台') > -1">
            <template #default="scope">
              <span>{{scope.row.platformType==-1?'不限':scope.row.platformType==1?'Android':scope.row.platformType==2?'IOS':'其它'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="package_name" label="包名/渠道" v-if="checkColList.indexOf('包名/渠道') > -1">
            <template #default="scope">
              <p>{{scope.row.packageName == '0'?'其他':scope.row.packageName}}</p>
              <p>{{scope.row.channel == '0'?'其他':scope.row.channel}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="用户场景" v-if="checkColList.indexOf('用户场景') > -1">
            <template #default="scope">
              <p v-for="item in userSceneArray" :key="item.value"><span v-if="item.value == scope.row.type + '>>' + scope.row.orderNum">{{item.label}}</span></p>
            </template>
          </el-table-column>
          <el-table-column prop="project" label="短信模板ID" v-if="checkColList.indexOf('短信模板ID') > -1"></el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <span>{{scope.row.status==0?'无效':scope.row.status==1?'有效':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editActivationDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-if="scope.row.status == 0" @click="updateState(scope.$index, scope.row, 1)">设为有效</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-if="scope.row.status == 1" @click="updateState(scope.$index, scope.row, 0)">设为无效</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getActivationSmsPageList, updateActivationSmsStatus, getActivationSmsChannelPackage } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import ActivationDialog from "./components/ActivationDialog";
import SearchComponents from "../../components/SearchComponents";

export default {
  name: "SmsActivation",
  components: { SearchComponents },
  data() {
    return {

      //状态
      statusArray: [
        {label: "不限",value: -1},
        {label: "有效",value: 1},
        {label: "无效",value: 0}
      ],
      status: -1,

      //平台
      platformTypeArray: [
        {label: "不限",value: -1},
        {label: "Android",value: 1},
        {label: "IOS",value: 2}
      ],
      platformType: -1,

      // 用户场景
      userSceneArray: [
        {label: "不限",value: '-1>>-1'},
        {label: "第一条短信：注册但未进入",value: '2>>1'},
        {label: "第二条短信：注册但未进入",value: '2>>2'},
        {label: "第三条短信：注册但未进入",value: '2>>3'},
        {label: "第四条短信：注册但未进入",value: '2>>4'},
        {label: "第一条短信：进入但未活跃",value: '1>>1'},
        {label: "第二条短信：进入但未活跃",value: '1>>2'}
      ],
      userScene: '-1>>-1',

      channelPackageArray: [
        {label: '全部', value: ''}
      ],
      channelPackage: '',
      //渠道
      channelArray: [
        {label: '全部', value: ''}
      ],
      channel: '',

      //包名
      packageNameArray: [
        {label: '全部', value: ''}
      ],
      packageName: '',

      // 短信来源
      smsSourceArray: [
        {label: "赛邮短信", value: 1},
        // {label: "示远短信", value: 2}
      ],
      smsSource: 1,

      //搜索
      searchTypeList: [
        {label : '城市名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      //刷新组
      colList: ['应用名', '平台', '包名/渠道', '用户场景', '短信模板ID', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.searchValue = '';
      this.status = -1;
      this.platformType = -1;
      this.smsSource = 1;
      this.userScene = '-1>>-1';
      this.channel = '';
      this.packageName = '';
      this.channelPackage = '';
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['status'] = this.status;
      param['platformType'] = this.platformType;
      param['packageName'] = this.packageName;
      param['channel'] = this.channel;
      param['smsSource'] = this.smsSource;
      let strArr = this.userScene.split('>>');
      param['type'] = strArr[0];
      param['orderNum'] = strArr[1];
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getActivationSmsPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editActivationDialog(idx, row) {
      let _title = '';
      let activationForm = {}
      if (idx > -1) {
        _title = '编辑'
        activationForm = Object.assign({}, row);
      }else {
        _title = '新建'
      }
      Dialog.open({
        title: _title,
        component: ActivationDialog,
        data: {
          activationForm: activationForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      let arr = []
      arr.push(row.id)
      param['idArr'] = arr;
      param['status'] = state;
      postFormData(updateActivationSmsStatus, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.status = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },

    //获取渠道
    getChannelPackage() {
      getFormData(getActivationSmsChannelPackage).then((data) => {
        let {code, msg} = data;
        if (code == 200) {
          console.log(data)
          let channelList = data.data.channelList;
          let packageNameList = data.data.packageNameList;
          channelList.map(item => {
            let obj = {}
            if(item == '0') {
              obj.label = '其他';
              obj.value = item;
            }else {
              obj.label = item;
              obj.value = item;
            }
            this.channelArray.push(obj)
          })
          packageNameList.map(item => {
            let obj = {}
            if(item == '0') {
              obj.label = '其他';
              obj.value = item;
            }else {
              obj.label = item;
              obj.value = item;
            }
            this.packageNameArray.push(obj)
          })
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    platformChange(val) {
      if(val == 1) {
        this.channelPackageArray = this.packageNameArray;
      } else if (val == 2) {
        this.channelPackageArray = this.channelArray;
      }
      this.channelPackage = ''
      this.channel = ''
      this.packageName = ''
    },

    cpChange(val) {
      if ( this.platformType == 1) {
        this.channel = ''
        this.packageName = val
      } else if ( this.platformType == 2) {
        this.channel = val
        this.packageName = ''
      }
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getChannelPackage();
    this.getPage();
  }
}
</script>

<style scoped>

</style>
